import axios from "axios";
const API_HOST = process.env.REACT_APP_API_HOST;

 class userService{
  createNewUser(data, user) {
    return axios({
      method: "post",
      url: API_HOST + "/api/admin/user/register",
      data: data,
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    });
  }

  
  getUserName(user, serach) {
    const noSpacesSerach = serach?.replace(/\s+/g, "");
    return axios({
      method: "get",
      url: `${API_HOST}/api/get-customer?search=${noSpacesSerach}`,
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    });
  }

    getUserProfile(user , page, search , limit) {
    console.log(user);
    return axios({
      method: "get",
      url: `${API_HOST}/api/user-profile/?page=${page}&search=${search}&pageSize=${limit}`,
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    });
  }


  userAllTransactionReport(user , data, page , limit) {
    return axios({
      method: "post",
      url: `${API_HOST}/api/user/transaction?page=${page}&pageSize=${limit}`,
      data:  data,
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    });
  }

}


export default new userService();